// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zpGx","question":"styles_question__EsDSl","description":"styles_description__xMTRu"};